import {isString} from 'ramda-adjunct';

import {getRowCellValue, type RowData} from 'features/eag-grid';

import {SERVICE_ITEMS_GRID_COLUMNS} from '../constants/serviceItemsGridColumns';

/**
 * Maps grid rows to the `{serviceItemId, serviceJobId}` pairs the bulk service-item
 * mutations take, reading BOTH ids from the row's cells. For grids whose rows span
 * multiple jobs (the order's All items grid) there is no single host-known job id, so
 * each row's own `serviceJobId` cell is authoritative. Rows missing either cell are
 * dropped — a payload with a blank job id would be rejected by the backend anyway.
 */
export const mapRowsToServiceItems = (rows: RowData[]) =>
  rows.flatMap((row) => {
    const serviceItemId = getRowCellValue(row, SERVICE_ITEMS_GRID_COLUMNS.serviceOrderJobItemId);
    const serviceJobId = getRowCellValue(row, SERVICE_ITEMS_GRID_COLUMNS.serviceJobId);
    return isString(serviceItemId) && isString(serviceJobId) ? [{serviceItemId, serviceJobId}] : [];
  });
